export const ENROLL_BY_WEBHOOK_TOOLTIP =
  'Enroll contacts by sending a GET request to the webhook URL from your CRM, Zapier, or backend.'
